import { Fragment } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Href } from "../../../../Constants/Constants";
import { RecentData } from "../../../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../Utils";

const SliderSection = () => {
  const settings = {
    slidesPerView: 5,
    spaceBetween: 25,
    loop: true,
    modules: [Autoplay],
    breakpoints: {
      320: {
        slidesPerView: 3,
      },
      360: {
        slidesPerView: 4,
      },
      480: {
        slidesPerView: 5,
      },
      600: {
        slidesPerView: 6,
      },
      788: {
        slidesPerView: 8,
      },
      801: {
        slidesPerView: 3,
      },
      1367: {
        slidesPerView: 5,
      },
    },
  };
  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-between px-4 pt-3">
        <h3>Status</h3>
        <a href={Href}>
          <h5 className="font-primary" id="status1">
            View All
          </h5>
        </a>
      </div>
      <div className="recent-slider recent-chat">
        <Swiper {...settings} className="mySwiper">
          {RecentData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="recent-box">
                <div className="recent-profile">
                  <Image className="bg-img" src={dynamicImage(`avtar/${item.image}.jpg`)} alt="Avatar" />
                  <h6>{item.title}</h6>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Fragment>
  );
};

export default SliderSection;
